import { EntityIndex, EntityID, World } from "@latticexyz/recs";
import { ActionSystem } from "@latticexyz/std-client";
import { NetworkLayer } from "../../Network";

export function rest(
  context: {
    network: NetworkLayer;
    actions: ActionSystem;
    world: World;
  },
  rester: EntityIndex
) {
  const {
    network: { api: networkApi },
    world,
    actions,
  } = context;

  const actionID = `rest ${Date.now()}` as EntityID; // Date.now to have the actions ordered in the component browser

  actions.add({
    id: actionID,
    components: {},
    on: rester,
    requirement: () => true,
    updates: () => [],
    execute: async () => {
      return networkApi.rest(world.entities[rester]);
    },
  });
}
